import { useEffect } from 'react';

export function useTimer(callback: () => void, interval: number) {
	useEffect(() => {
		const id = setInterval(callback, interval);

		return () => clearInterval(id);
	}, [callback, interval]);
}
